import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_REQUEST_GENERALS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_REQUEST_GENERAL:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_REQUEST_GENERAL:
      // return { ..._.mapKeys(action.payload, "Id") };
      return { ...state, [action.payload.Id]: action.payload };

    default:
      return state;
  }
};
